<template>
  <div class="form-control" :class="{ 'form-control--invalid': validateError }">
    <textarea
      required
      class="form-control__textarea"
      :value="element"
      @input="$emit('input', $event.target.value)"
    />
    <label class="form-control__label">
      {{ placeholder }}
      <span class="form-control__label_required" v-if="required">*</span>
    </label>
    <p class="form-control__error">{{ validateError }}</p>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: { type: String },
    element: { type: String },
    required: { type: Boolean, default: false },
    validateError: { type: String, default: "" },
  },
  data() {
    return {
      showText: true,
    };
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  width: 100%;
  position: relative;
  margin-top: 10px;
  &__icon {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
  &__label {
    position: absolute;
    @include type($fw: 500);
    color: rgba($color: $lightBlack, $alpha: 0.7);
    top: 25%;
    left: 2.4rem;
    transform: translateY(-50%);
    padding: 1px 1.1rem;
    background-color: $white;
    transition: all 0.1s ease;
    pointer-events: none;
    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
      font-size: 14px;
    }
    &_required {
      font-size: 18px;
      font-weight: 600;
      color: $error;
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      }
    }
  }
  &__textarea {
    min-height: 14.5rem;
    padding: 2.4rem 2.4rem 2.4rem 2.7rem;
    border: 0.5px solid $lightGrey;
    border-radius: 12px;
    @include type();
    &:-webkit-autofill {
      background-color: rgba(255, 255, 255, 1) !important;
      background-image: none !important;
      -webkit-box-shadow: 0 0 0px 10em white inset !important;
      -webkit-text-fill-color: $black !important;
    }
    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
      font-size: 14px;
    }
  }
  &__textarea:focus ~ &__label,
  &__textarea:valid ~ &__label {
    top: 0;
  }
  &__error {
    position: absolute;
    @include type($fs: 12px, $fw: 500);
    color: $error;
    padding-top: 3px;
  }
  &--invalid {
    .form-control__textarea {
      border-color: $error;
    }
  }
}
</style>